<template>
  <!-- 校园端--账户管理 -->
  <div class="page">
    <div class="paginations">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <el-form-item label="账户名称：" prop="loginName">
            <el-input
              size="small"
              v-model="searchData.loginName"
              placeholder="请输入用户名称"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item label=" 用户名称：" prop="userName">
            <el-input
              size="small"
              v-model="searchData.userName"
              placeholder="请输入用户名称"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item label="学校名称" prop="schoolName">
            <el-input
              size="small"
              v-model="searchData.schoolName"
              placeholder="请输入学校名称"
              style="width: 180px"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="专业名称："
            prop="professional"
            class="demo-form-inline"
          >
            <el-select
              size="small"
              v-model="searchData.professional"
              clearable
              filterable
              style="width: 180px"
            >
              <el-option
                v-for="item in drowDown.zykArrList"
                :key="item.zykid"
                :label="item.zykName"
                :value="item.zykid"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="角色搜索：" prop="roleId">
            <el-select
              size="small"
              v-model="searchData.roleId"
              clearable
              filterable
              style="width: 180px"
            >
              <el-option
                v-for="item in drowDown.roleList"
                :key="item.zykid"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search('')"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>

          <!-- 添加按钮 -->
          <el-form-item class="add">
            <div class="addition">
              <el-button @click="add('uploadBox')">
                添加
                <i class="h_icon icon-add"></i>
              </el-button>
              <el-button @click="cutOut(true)">批量删除</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="table_box">
        <!-- <div class="biaoge">
          <table cellpadding="0" cellspacing="0" width="100%" class="course">
            <tr>
              <th>账号名称</th>
              <th>用户名称</th>
              <th>学校名称</th>
              <th>邮箱</th>
              <th>专业</th>
              <th>添加时间</th>
              <th>角色</th>
            </tr>

            <tr v-for="(item,index) in tableObj.list" :key="index" v-show="tableObj.list.length > 0">
              <td>{{item.loginName}}</td>
              <td>{{item.userName}}</td>
              <td>{{item.institution}}</td>
              <td>{{(item.email)}}</td>
              <td>{{(item.professional)}}</td>
              <td>{{(item.professional)}}</td>
              <td>{{(item.role)}}</td>
            </tr>
            <tr v-show="tableObj.list.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div> -->

        <el-table :data="tableObj.list" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="loginName" label="账号名称" align="center"/>
          <el-table-column prop="userName" label="用户名称" align="center"/>
          <el-table-column prop="institution" label="学校名称" align="center"/>
          <el-table-column prop="email" label="邮箱" align="center"/>
          <el-table-column prop="professional" label="专业" align="center"/>
          <el-table-column prop="createTime" label="添加时间" align="center"/>
          <el-table-column prop="role" label="角色" align="center"/>
          <el-table-column label="是否启用" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.enabled"
                active-color="#00ffffe5"
                inactive-color="#1bfaf285"
                @change="changeEnabled($event, scope.row, 'uploadBox.data')"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="90">
            <template slot-scope="scope">
              <i
                class="icona icon-major"
                title="分配专业"
                @click="major(scope.row)"
              ></i>
              <i
                class="icona icon-bindingRole"
                title="绑定角色"
                @click="userBindingRole(scope.row.id)"
              ></i>
              <i
                class="icona icon-bindingPlatform"
                v-if="scope.row.userType == 13"
                title="绑定平台"
                @click="userBindingPlatform(scope.row)"
              ></i>
              <i
                class="icona icon-edit"
                title="编辑"
                @click="edit(scope.row)"
              ></i>
              <i
                class="icona icon-delete"
                title="删除"
                @click="cutOut(false,[scope.row.id])"
              ></i>
            </template>
          </el-table-column>
        </el-table>

        <!-- <div class="chart_box" style="margin-top: 50px;">
          <h4>3.4 访问量较多的教师</h4>
          <div class="biaoge">
            <table border="1" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
              <tr>
                <th>排名</th>
                <th>姓名</th>
                <th>所属院校</th>
                <th>访问量</th>
              </tr>

              <tr v-for="(item,index) in tearcherList.dataList" :key="index" v-show="tearcherList.dataList.length > 0">
                <td>{{index+1}}</td>
                <td>{{item.author}}</td>
                <td>{{item.school}}</td>
                <td>{{parseInt(item.num)}}</td>
              </tr>
              <tr v-show="tearcherList.dataList.length == 0" class="nothing">
                <td colspan="6">无</td>
              </tr>
            </table>
          </div>
          <div class="chart_name" style="margin-top: 240px;">图9 访问量较多的教师（前10名）</div>
        </div> -->

        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :pageSize="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form
        ref="uploadBox"
        :model="uploadBox.data"
        :rules="uploadBox.rules"
        label-width="95px"
      >
        <el-form-item label="账号：" prop="loginName" required>
          <el-input
            v-model="uploadBox.data.loginName"
            placeholder="请输入。。。"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="userName" required>
          <el-input
            v-model="uploadBox.data.userName"
            placeholder="请输入。。。"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email" required>
          <el-input
            v-model="uploadBox.data.email"
            placeholder="请输入。。。"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password" required>
          <el-input
            type="password"
            v-model="uploadBox.data.password"
            show-password
            placeholder="请输入。。。"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="description" required>
          <el-input
            type="textarea"
            v-model="uploadBox.data.description"
            placeholder="请输入。。。"
          ></el-input>
        </el-form-item>
        <el-form-item label="省份：" prop="province" required>
          <el-select
            v-model="uploadBox.data.province"
            placeholder="请选择"
            :popper-append-to-body="false"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="(item, index) in provinceList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校名称：" prop="institution" required>
          <el-select
            v-model="uploadBox.data.institution"
            placeholder="请选择"
            :popper-append-to-body="false"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="(item, index) in shcoolList"
              :key="index"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用：" prop="enabled" required>
          <el-radio-group v-model="uploadBox.data.enabled">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="绑定角色：">
          <el-input
            @focus="bindRoleClick"
            type="input"
            v-model="uploadBox.data.role"
            placeholder="请选择"
            readonly
          />
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 分配专业 -->
    <el-dialog
      :title="specialtyBox.title"
      :visible.sync="specialtyBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up distribute"
      append-to-body
      :before-close="handleClose"
    >
      <div class="specialtySearch">
        <el-input
          placeholder="请输入菜单快速勾选"
          v-model="specialtyBox.data.filterText"
        ></el-input>
        <div align="left" style="color: #c0c4cc">
          <el-checkbox
            v-model="specialtyBox.data.checked"
            @change="checkedAll"
          />
          全选/反选
          <div class="distributionBox">
            <el-tree
              :data="specialtyBox.data.zykIds"
              show-checkbox
              node-key="value"
              ref="specialtyTree"
              highlight-current
              :default-checked-keys="specialtyBox.data.defaultCheckedKeys"
              :props="specialtyBox.data.defaultProps"
              :filter-node-method="filterNodeSpecialty"
              @check="handleCheckzykIds"
            >
            </el-tree>
          </div>
          <div class="tx-center">
            <el-button size="small" @click="specialtySubmitForm"
              >确定</el-button
            >
            <el-button size="small" @click="handleClose">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 用户绑定角色 -->
    <el-dialog
      :title="bindingRoleBox.title"
      :visible.sync="bindingRoleBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
    >
      <div class="distributionBox">
        <el-tree
          :data="bindingRoleBox.data.bindingRoleIds"
          v-if="bindingRoleBox.isRoleIds"
          :default-checked-keys="bindingRoleBox.data.checkedRoleIds"
          show-checkbox
          node-key="value"
          ref="bindingRoleTree"
          highlight-current
          :props="bindingRoleBox.data.bindingRoles"
          @check="handleCheckRoleIds"
        >
        </el-tree>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="bindingRoleSubmitForm">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 用户绑定平台 -->
    <el-dialog
      :title="platformBox.title"
      :visible.sync="platformBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up distribute"
      append-to-body
      :before-close="handleClose"
    >
      <div class="specialtySearch">
        <el-input
          placeholder="请输入菜单快速勾选"
          v-model="platformBox.data.filterText"
          style="margin-bottom: 10px"
        ></el-input>
        <div class="distributionBox">
          <el-tree
            :data="platformBox.data.bindingPlatform"
            v-if="platformBox.isPlatform"
            :default-checked-keys="platformBox.data.checkedPlatform"
            show-checkbox
            node-key="value"
            ref="bindingPlatformTree"
            highlight-current
            :props="platformBox.data.bindingPlatforms"
            :filter-node-method="filterNodePlatform"
            @check="handleCheckPlatform"
          >
          </el-tree>
        </div>
        <div class="tx-center">
          <el-button size="small" @click="bindingPlatformSubmitForm"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页

export default {
  components: {
    pageNumber,
  },
  data() {
    var validateMailbox = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱"));
      } else {
        var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (!reg.test(value)) {
          callback(new Error("邮箱格式不正确"));
        } else {
          callback();
        }
      }
    };
    return {
      searchData: {
        loginName: "", // 账号名称
        loginType: 1, //用户类型 0国家端 1校园端 2平台端
        professional: "", // 所属专业
        roleId: "", // 角色ID
        schoolName: "", // 学校名称
        userName: "", // 用户名称
        pageDto: {
          // 分页对象
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },

      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      // 添加弹窗
      uploadBox: {
        show: false,
        title: "添加用户",
        data: {
          id: null,
          loginType: 1, //用户类型 0国家端 1校园端 2平台端
          loginName: "",
          userName: "",
          email: "",
          password: "",
          description: "",
          province: "",
          institution: "",
          enabled: "1",
          roleId:""
        },
        rules: {
          loginName: [
            { required: true, message: "请输入账号", trigger: "blur" },
          ],
          userName: [
            { required: true, message: "请输入姓名", trigger: "blur" },
          ],
          email: [{ validator: validateMailbox, trigger: "blur" }],
          password: [
            { required: true, message: "请输入密码", trigger: "blur" },
          ],
          description: [
            { required: true, message: "请填写备注", trigger: "blur" },
          ],
          province: [
            { required: true, message: "请选择省份", trigger: "change" },
          ],
          institution: [
            { required: true, message: "请选择学校名称", trigger: "change" },
          ],
          enabled: [
            { required: true, message: "请选择是否启用", trigger: "blur" },
          ],
        },
      },
      provinceList: [
        "河北省",
        "山西省",
        "辽宁省",
        "吉林省",
        "黑龙江省",
        "江苏省",
        "浙江省",
        "安徽省",
        "福建省",
        "江西省",
        "山东省",
        "河南省",
        "湖北省",
        "湖南省",
        "广东省",
        "海南省",
        "四川省",
        "贵州省",
        "云南省",
        "陕西省",
        "甘肃省",
        "青海省",
        "北京",
        "天津",
        "上海",
        "重庆",
      ], //省份列表
      shcoolList: [],
      // 分配专业弹窗
      specialtyBox: {
        show: false,
        title: "分配专业",
        data: {
          checked: false, //checkbox的值
          filterText: "",
          defaultCheckedKeys: [],
          professionUserId: null,
          zykIds: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
        },
      },
      // 用户绑定角色
      bindingRoleBox: {
        show: false,
        title: "绑定角色",
        isRoleIds: true,
        data: {
          bindingRoleUserId: null,
          checkedRoleIds: [], //默认选中
          bindingRoleIds: [],
          bindingRoles: {
            children: "children",
            label: "name",
          },
        },
      },
      // 绑定平台
      platformBox: {
        show: false,
        title: "绑定平台",
        isPlatform: true,
        bindingPlatformUserId: null,
        data: {
          filterText: "",
          bindingPlatform: [], //默认选中
          checkedPlatform: [],
          bindingPlatforms: {
            children: "children",
            label: "name",
          },
        },
      },

      // 所有的下拉框
      drowDown: {
        zykArrList: [],
        roleList: [],
      },
      isFormRoleOpt: false,
      selectRowId: [],
    };
  },
  watch: {
    "specialtyBox.data.filterText"(val) {
      this.$refs.specialtyTree.filter(val);
    },
    "platformBox.data.filterText"(val) {
      this.$refs.bindingPlatformTree.filter(val);
    },
  },
  created() {
    this.accessSchool();
    this.search();
    this.getRoleList(); //    获取角色

    this.drowDown.zykArrList = JSON.parse(sessionStorage.getItem("zykArr"));
    this.drowDown.zykArrList = this.drowDown.zykArrList.map((item) => {
      let i = item.zykName.indexOf(" ") + 1;
      let zykName = item.zykName.slice(i, item.zykName.length);
      let zykid = item.zykId;
      return {
        zykName,
        zykid,
      };
    });
  },
  methods: {
    // 获取角色
    getRoleList() {
      this.$axios
        .post(this.$apiurls.account_getUserRoleList, 1, {
          loading: false,
        })
        .then((res) => {
          this.drowDown.roleList = res.data.map((item) => {
            let name = item.name;
            let value = item.id;
            return {
              name,
              value,
            };
          });
        });
    },
    // 获取学校
    accessSchool() {
      this.$axios
        .post(this.$apiurls.account_getSchoolSelectionDatas, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.shcoolList = res.data;
          }
        });
    },
    // 过滤分配专业树形结构搜索
    filterNodeSpecialty(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 过滤绑定平台树形结构搜索
    filterNodePlatform(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 查询表格数据
    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1;
      this.tableObj.jumpTo = type ? type : 1;
      this.$axios
        .post(this.$apiurls.account_getList, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.list.length; i++) {
              if (res.data.list[i].enabled == 1) {
                res.data.list[i].enabled = true;
              } else {
                res.data.list[i].enabled = false;
              }
            }
            this.tableObj.list = res.data.list;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.userName = "";
      this.searchData.loginName = "";
      this.searchData.schoolName = "";
      this.searchData.professional = "";
      this.searchData.roleId = "";
      this.search("");
    },
     // 表格多选
     handleSelectionChange(val) {
      let idArr = [];
      for (const item of val) {
        idArr.push(item.id);
      }
      this.selectRowId = idArr;
    },
    // 专业
    major(row) {
      let type = row.role.indexOf("省级") === -1 ? 1 : 2;
      this.specialtyBox.data.professionUserId = row.id;
      this.$axios
        .post(
          this.$apiurls.account_specialty,
          { userId: row.id, type: this.$store.state.statusRadio },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.specialtyBox.show = true;
            this.$store.commit("modifyVague", true);
            this.specialtyBox.data.zykIds = res.data.allProfessionDatas;
            this.specialtyBox.data.defaultCheckedKeys = res.data.bindZykIds;
            if (
              res.data.bindZykIds.length == this.specialtyBox.data.zykIds.length
            ) {
              this.specialtyBox.data.checked = true;
            } else {
              this.specialtyBox.data.checked = false;
            }
          }
        });
    },
    // 选中该专业时判断是否已经全选或未全选
    handleCheckzykIds(data, checked) {
      if (checked.checkedKeys.length == this.specialtyBox.data.zykIds.length) {
        this.specialtyBox.data.checked = true;
      } else {
        this.specialtyBox.data.checked = false;
      }
    },
    // 是否全选该专业
    checkedAll() {
      if (this.specialtyBox.data.checked) {
        //全选
        this.$refs.specialtyTree.setCheckedNodes(this.specialtyBox.data.zykIds);
      } else {
        //取消选中
        this.$refs.specialtyTree.setCheckedKeys([]);
      }
    },
    // 确定分配专业
    specialtySubmitForm() {
      this.$axios
        .post(
          this.$apiurls.account_bindUserProfessions,
          {
            zykIds: this.$refs.specialtyTree.getCheckedKeys(),
            userId: this.specialtyBox.data.professionUserId,
            // roleId: this.$refs.bindingRoleTree.getCheckedKeys()[0] ? this.$refs.bindingRoleTree.getCheckedKeys()[0] : 0,
            // userId: this.bindingRoleBox.data.bindingRoleUserId
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data) {
              this.specialtyBox.show = false;
              this.$store.commit("modifyVague", false);
              this.$message({
                message: "分配专业成功！",
                type: "success",
              });
              this.search();
            } else {
              this.$message.error(res.message);
            }
          }
        });
    },
    // 获取角色
    userBindingRole(id) {
      this.bindingRoleBox.data.bindingRoleUserId = id;
      this.$axios
        .post(this.$apiurls.account_getAllRoleAndBindRoleId, id, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.bindingRoleBox.show = true;
            this.bindingRoleBox.data.bindingRoleIds = res.data.allRoleDatas;
            this.$store.commit("modifyVague", true);
            let role = id != "0" ? res.data.bindRoleId : null;
            this.bindingRoleBox.data.checkedRoleIds = [role]; //设置默认选中的值
            if (id != "0")
            for (let i = 0; i < res.data.allRoleDatas.length; i++) {
              if (role) {
                if (res.data.allRoleDatas[i].value == role) {
                  res.data.allRoleDatas[i].disabled = false;
                } else {
                  res.data.allRoleDatas[i].disabled = true;
                }
              } else {
                if (res.data.allRoleDatas[i].value == role) {
                  res.data.allRoleDatas[i].disabled = false;
                }
              }
            }
          }
        });
    },
    // 选择角色时
    handleCheckRoleIds(data, check) {
      if (check.checkedKeys.length == 0) {
        for (
          let i = 0;
          i < this.bindingRoleBox.data.bindingRoleIds.length;
          i++
        ) {
          this.bindingRoleBox.data.bindingRoleIds[i].disabled = false;
        }
      } else {
        for (
          let i = 0;
          i < this.bindingRoleBox.data.bindingRoleIds.length;
          i++
        ) {
          if (
            this.bindingRoleBox.data.bindingRoleIds[i].value ==
            check.checkedKeys[0]
          ) {
            this.bindingRoleBox.data.bindingRoleIds[i].disabled = false;
          } else {
            this.bindingRoleBox.data.bindingRoleIds[i].disabled = true;
          }
          this.$refs.bindingRoleTree.setCheckedKeys(check.checkedKeys);
        }
      }
      this.bindingRoleBox.isRoleIds = false;
      this.$nextTick(() => {
        this.bindingRoleBox.data.checkedRoleIds = check.checkedKeys;
        this.bindingRoleBox.isRoleIds = true;
      });
    },
    //绑定角色
    bindingRoleSubmitForm() {
      let roleId = this.$refs.bindingRoleTree.getCheckedKeys()[0]
        ? this.$refs.bindingRoleTree.getCheckedKeys()[0]
        : 0;
      let node = this.$refs.bindingRoleTree.getCheckedNodes();
      if (this.isFormRoleOpt) {
        this.uploadBox.data.role = node[0].name;
        this.uploadBox.data.roleId = roleId;
        this.bindingRoleBox.show = false;
        this.uploadBox.show = true;
        this.isFormRoleOpt = false;
        return false;
      }
      this.$axios
        .post(
          this.$apiurls.account_bindUserRole,
          {
            roleId: roleId,
            userId: this.bindingRoleBox.data.bindingRoleUserId,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data) {
              this.$message({
                message: "绑定角色成功！",
                type: "success",
              });
            } else {
              this.$message.error("绑定角色失败！");
            }
            this.bindingRoleBox.show = false;
            this.$store.commit("modifyVague", false);
            this.search();
          }
        });
    },

    // 获取平台
    userBindingPlatform(row) {
      this.platformBox.data.bindingPlatformUserId = row.id;
      this.$axios
        .post(this.$apiurls.account_getAllPlatformInfos, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.platformBox.show = true;
            this.platformBox.data.bindingPlatform = res.data;
            this.$store.commit("modifyVague", true);
            this.platformBox.data.checkedPlatform = [row.platformId]; //设置默认选中的值

            for (let i = 0; i < res.data.length; i++) {
              if (row.platformId) {
                if (res.data[i].value == row.platformId) {
                  res.data[i].disabled = false;
                } else {
                  res.data[i].disabled = true;
                }
              } else {
                if (res.data[i].value == row.platformId) {
                  res.data[i].disabled = false;
                }
              }
            }
          }
        });
    },
    // 选择平台时
    handleCheckPlatform(data, check) {
      if (check.checkedKeys.length == 0) {
        for (let i = 0; i < this.platformBox.data.bindingPlatform.length; i++) {
          this.platformBox.data.bindingPlatform[i].disabled = false;
        }
      } else {
        for (let i = 0; i < this.platformBox.data.bindingPlatform.length; i++) {
          if (
            this.platformBox.data.bindingPlatform[i].value ==
            check.checkedKeys[0]
          ) {
            this.platformBox.data.bindingPlatform[i].disabled = false;
          } else {
            this.platformBox.data.bindingPlatform[i].disabled = true;
          }
          this.$refs.bindingPlatformTree.setCheckedKeys(check.checkedKeys);
        }
      }
      this.platformBox.isPlatform = false;
      this.$nextTick(() => {
        this.platformBox.data.checkedPlatform = check.checkedKeys;
        this.platformBox.isPlatform = true;
      });
    },
    // 绑定平台
    bindingPlatformSubmitForm() {
      this.$axios
        .post(
          this.$apiurls.account_bindUserPlatform,
          {
            platformId: this.$refs.bindingPlatformTree.getCheckedKeys()[0]
              ? this.$refs.bindingPlatformTree.getCheckedKeys()[0]
              : "",
            userId: this.platformBox.data.bindingPlatformUserId,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data) {
              this.$message({
                message: "绑定平台成功！",
                type: "success",
              });
            } else {
              this.$message.error("绑定平台失败！");
            }
            this.platformBox.show = false;
            this.$store.commit("modifyVague", false);
            this.search();
          }
        });
    },
    // 编辑
    edit(row) {
      this.uploadBox.title = "编辑用户";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      this.uploadBox.data.id = row.id;
      this.uploadBox.data.loginName = row.loginName;
      this.uploadBox.data.userName = row.userName;
      this.uploadBox.data.email = row.email;
      this.uploadBox.data.password = row.password;
      this.uploadBox.data.description = row.description;
      this.uploadBox.data.province = row.province;
      this.uploadBox.data.institution = row.institution;
      this.uploadBox.data.role = row.role;
      this.uploadBox.data.enabled = row.enabled ? "1" : "0";
    },
    // 删除
    cutOut(flag,id) {
      let str = "";
      if (flag) {
        str = "此操作将永久删除该账户, 是否继续?";
        if (this.selectRowId.length === 0)
          return this.$message.warning({
            message: "请先选择要批量删除的行！",
          });
        id = this.selectRowId;
      } else str = "此操作将永久删除该账户, 是否继续?";
      this.$store.commit("modifyVague", true);
      this.$confirm(str, "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$axios
            .post(this.$apiurls.account_deleteUserInfo, id, {
              loading: false,
            })
            .then((res) => {
              if (res) {
                if (res.data) {
                  this.search("");
                  this.$message({
                    message: "删除成功！",
                    type: "success",
                  });
                } else {
                  this.$message.error("删除失败！");
                }
              }
              this.$store.commit("modifyVague", false);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
          this.$store.commit("modifyVague", false);
        });
    },
    // 是否启用
    changeEnabled(value, row) {
      this.uploadBox.data.id = row.id;
      this.uploadBox.data.loginName = row.loginName;
      this.uploadBox.data.userName = row.userName;
      this.uploadBox.data.email = row.email;
      this.uploadBox.data.password = row.password;
      this.uploadBox.data.description = row.description;
      this.uploadBox.data.province = row.province;
      this.uploadBox.data.institution = row.institution;
      this.uploadBox.data.enabled = row.enabled ? "1" : "0";
      this.uploadBox.data.roleId=row.userType
      this.$axios
        .post(this.$apiurls.account_saveOrUpdateUser, this.uploadBox.data, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            if (res.data) {
              this.search("");
              this.$message({
                message: !value ? "关闭成功！" : "启用成功！",
                type: "success",
              });
            }
          }
        });
    },

    // 添加按钮
    add() {
      this.uploadBox.title = "添加用户";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      this.uploadBox.data.id = 0;
      this.uploadBox.data.loginName = "";
      this.uploadBox.data.userName = "";
      this.uploadBox.data.email = "";
      this.uploadBox.data.password = "";
      this.uploadBox.data.description = "";
      this.uploadBox.data.province = "";
      this.uploadBox.data.institution = "";
      this.uploadBox.data.enabled = "1";
      this.uploadBox.data.role = "";
    },
    // 关闭添加弹窗
    handleClose() {
      if (this.isFormRoleOpt) {
        this.uploadBox.show = true;
        this.isFormRoleOpt = false;
      } else this.uploadBox.show = false;
      this.specialtyBox.show = false;
      this.bindingRoleBox.show = false;
      this.platformBox.show = false;
      this.$nextTick(() => {
        if (this.$refs.specialtyTree) {
          this.$refs.specialtyTree.setCheckedKeys([]); //清空分配专业选中的值
        }
        if (this.$refs.bindingRoleTree) {
          this.$refs.bindingRoleTree.setCheckedKeys([]); //清空绑定角色选中的值
        }
        if (this.$refs.bindingPlatformTree) {
          this.$refs.bindingPlatformTree.setCheckedKeys([]); //清空绑定平台选中的值
        }
      });
      this.$store.commit("modifyVague", false);
    },
    // 绑定角色
    bindRoleClick() {
      this.uploadBox.show = false;
      this.bindingRoleBox.show = true;
      this.isFormRoleOpt = true;
      this.$store.commit("modifyVague", true);
      let flag = this.uploadBox.data.id || "0";
      this.userBindingRole(flag);
    },
    // 添加用户
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          this.$axios
            .post(this.$apiurls.account_saveOrUpdateUser, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res) {
                if (res.data) {
                  this.$message({
                    message: this.uploadBox.data.id
                      ? "编辑成功！"
                      : "添加成功！",
                    type: "success",
                  });
                }
                this.uploadBox.show = false;
                this.$store.commit("modifyVague", false);
                this.search();
              }
            });
        }
      });
    },
    opened() {
      this.$refs.uploadBox.clearValidate();
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>

<style lang="scss" scoped>
.el-form {
  height: 100%;
}

.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

// 弹窗
.down_box .el-form-item {
  margin-bottom: 22px;
}
.down_box .el-form-item:last-child {
  margin-bottom: 0px;
}
.down_box ::v-deep .el-form-item__content .el-select {
  width: 100%;
}

// 分配专业
.distribute ::v-deep .el-dialog__body {
  padding: 0px 20px 20px;
}
.distributionBox {
  max-height: 500px;
  overflow-y: auto;
  margin-bottom: 10px;
}
.specialtySearch {
  width: 92%;
  margin: 10px auto;
}
.specialty_box {
  height: 470px;
  overflow-y: auto;
  // background: #a5a4bf;
  margin-bottom: 60px;
  margin-right: 20px;
}
.specialty_bottom {
  position: absolute;
  bottom: -45px;
  right: 38%;
}
.el-tree,
::v-deep.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content,
::v-deep.el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}
</style>

<style>
.biaoge {
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 35px;
  line-height: 35px;
  color: #707f9d;
  font-size: 20px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}

.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: transparent;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
}
.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  position: absolute;
  display: "";
  width: "";
  height: "";
  border: none;
  border-style: "";
}
.el-select-dropdown__list {
  box-sizing: border-box;
  padding: -1px 0;
  background: rgba(26, 38, 72) !important;
}
.el-select-dropdown__item {
  color: #fff !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: transparent;
  border: 1px solid rgba(27, 246, 248);
}
.el-select-dropdown__item:hover span {
  font-size: 14px;
  transform: scale(1);
}
.el-select-dropdown__item.selected {
  color: rgba(27, 246, 248);
}
.add {
  margin-left: 75px;
}
.biaoge {
  width: 100%;
  color: #fff;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  /* margin: 0px 10px; */
}

.course tr {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}

.course td {
  border-top: 6px solid rgba(0, 0, 0, 0.2);
  border-bottom: 6px solid black;
}

.course tr:hover {
  background: rgba(32, 48, 88);
}

.course tr:nth-child(2n) {
  background: rgb(35, 42, 67);
}

.course tr:nth-child(2n-1) {
  background: rgb(35, 42, 67);
}

.course tr:first-child {
  background: rgb(32, 48, 88);
}
</style>
